module.exports = __webpack_public_path__ + "img/imgeditaddrbtdg.235bbc53.png";